import { render, staticRenderFns } from "./SingleSchoolSet.vue?vue&type=template&id=567353dc&scoped=true"
import script from "./SingleSchoolSet.vue?vue&type=script&lang=js"
export * from "./SingleSchoolSet.vue?vue&type=script&lang=js"
import style0 from "./SingleSchoolSet.vue?vue&type=style&index=0&id=567353dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567353dc",
  null
  
)

export default component.exports